<template>
  <div class="showRegulations">
    <!-- 加载过程 -->
    <div v-if="regulationsContents == null">
      <div class="spin">
        <font-awesome-icon icon="compass" />
      </div>
      <div>加载中，请稍候......</div>
    </div>

    <!-- 加载后 -->
    <div v-else class="main">
      <!-- 页眉标题 -->
      <el-row class="title">
        <!-- 在PC上显示法规名称， 在手机端不显示 -->
        <el-col :sm="22" class="show-xs-and-up-only"
          style="overflow:hidden; white-space:nowrap; text-overflow:ellipsis">
          <span class="title_text">{{regulationsContents[0].regulations_name}}</span>
          <span class="show-xs-and-up-only downloadIcon" @click="downloadRegulations()">
            <a>
              <font-awesome-icon icon="arrow-alt-circle-down" />
            </a>
          </span>
        </el-col>
        <el-col :sm="2" :xs="24" style="text-align:right">
          <el-dropdown trigger="click">
            <img src="static/images/1DING-MINLOG.svg" type="image/svg+xml" class="logo">
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="menu('home')">网站首页 / 常规搜索</el-dropdown-item>
              <el-dropdown-item @click.native="menu('advanceSearch')">高级搜索 / 精准搜索</el-dropdown-item>
              <!-- <el-dropdown-item @click.native="menu('standards')" class="left show-md-and-up-only">国内标准 / 国际标准</el-dropdown-item>
              <el-dropdown-item @click.native="menu('regulations')" class="left show-md-and-up-only">法律法规 / 监管要求</el-dropdown-item> -->
              <el-dropdown-item divided @click.native="user('regulations')" class="left show-md-and-up-only">个人中心 / 消费记录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>

      <!-- 法规正文内容 -->
      <el-row>
        <el-col :xs="24" :sm="14" class="contents">
          <contents :regulationsContents="regulationsContents" />
        </el-col>
        <el-col :sm="10" class="show-xs-and-up-only extension">
          <extension :regulationsExt="regulationsExt" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import Bus from "@/misc/bus.js";
  import contents from "@/components/regulations/show/contents.vue";
  import extension from "@/components/regulations/show/extension.vue";
  export default {
    components: {
      contents,
      extension
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.$store.dispatch(
          "regulations/getContents",
          vm.$route.query.regulations_code
        );
      });
    },
    computed: {
      showPayment() {
        return this.$store.state.payment.showPayment;
      },
      regulationsContents() {
        return this.$store.state.regulations.regulationsContents;
      },
      regulationsExt() {
        return {
          committee: this.$route.query.committee,
          regulations_code: this.$route.query.regulations_code,
          regulations_name: this.$route.query.regulations_name
        };
      }
    },
    methods: {
      menu(params) {
        const {
          href
        } = this.$router.resolve({
          path: "/" + params
        });
        window.open(href, "_blank");
      },
      user() {
        this.$store.dispatch("users/getConsumptionHistory");
        this.$store.dispatch("users/getUserInfo");
        Bus.$emit("showUserCenter", true);
      },
      downloadRegulations() {
        this.$store.dispatch("users/getConsumptionHistory");
        this.$store.dispatch("users/getUserInfo");
        Bus.$emit("showUserCenter", true);
        Bus.$emit("paied", false);
        this.$store.dispatch("order/setRechargeInfo", 5000);
        this.$store.dispatch("order/setOnceInfo", {
          description: this.regulationsExt.regulations_name,
          category: "regulations_download",
          code: this.regulationsExt.regulations_code,
          total_fee: 98, //单位分
          order_number: new Date().getTime(),
          body: "法规下载" // 发给微信端的订单描述
        });
      }
    }
  };
</script>

<style scoped>
  .showRegulations {
    padding: 0 0.1rem;
    text-align: center;
  }

  .showRegulations .logo {
    margin: -0.05rem 0;
    height: 0.2rem;
    cursor: pointer;
  }

  .showRegulations .main {
    text-align: left;
  }

  .showRegulations .title {
    margin: 0.2rem 0;
    border-bottom: 1px solid gray;
  }

  .showRegulations .title_text {
    position: relative;
    padding: 0.02rem;
    font-size: 0.15rem !important;
    font-weight: 900 !important;
  }

  .showRegulations .title_text:after {
    position: absolute;
    content: "";
    width: 100%;
    height: 5px;
    left: 0;
    bottom: -5px;
    background: #aa0000;
  }

  .showRegulations .downloadIcon {
    margin-left: 0.2rem;
  }

  .showRegulations .contents,
  .showRegulations .extension {
    height: calc(100vh - 1.1rem);
    padding: 0 0.1rem;
    border-left: 3px solid gray;
    border-right: 3px solid gray;
    border-radius: 20px;
  }

  .showRegulations .contents {
    margin-right: -1.5px;
  }

  .showRegulations .extension {
    margin-left: -1.5px;
  }
</style>